import React, { useEffect, useState } from "react";
import { Col, Input, Label, Row, TabContent, TabPane } from "reactstrap";
import AppModal from "../../../../Components/Common/AppModal";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { isEmpty } from "lodash";
import { toast } from "react-toastify";
import {
  assetTypeList,
  assetTypeData,
  assetTypeCreate,
  assetTypeCreateSuccess,
  assetTypeUpdate,
  assetTypeUpdateSuccess,
  assetTypeDelete,
  assetTypeDeleteSuccess,
} from "../../../../store/assetType/action";
import {
  assetStatusList,
  assetStatusCreate,
  assetStatusCreateSuccess,
  assetStatusUpdate,
  assetStatusUpdateSuccess,
  assetStatusDelete,
  assetStatusDeleteSuccess,
} from "../../../../store/assetStatus/action";
import {
  assetGroupList,
  assetGroupData,
  assetGroupCreate,
  assetGroupCreateSuccess,
  assetGroupUpdate,
  assetGroupUpdateSuccess,
  assetGroupDelete,
  assetGroupDeleteSuccess,
} from "../../../../store/assetGroup/action";
import DeleteModal from "../../../../Components/Common/DeleteModal";
import LoadingSpinner from "../../../../Components/Common/Spinner";
import SettingsPanel from "../../components/SettingsPanel";
import StatusViewEditComponent from "../components/statusViewEditComponent";
import "../../settings.styles.css";

const EMPTY_FORM = {
  Name: "",
  Description: "",
  CssColourBackground: "#ffffff",
  CssColourBorder: "#cccccc",
  CssColourText: "#000000",
  Order: "",
};

const EMPTY_STATUS = {
  Name: "New Status",
  CssColourText: "#000000",
  CssColourBackground: "#F4F0F0",
  FlagActive: null,
  FlagComplete: null,
};

const EMPTY_GROUP_FORM = {
  Name: "",
  Description: "",
  Brand: "",
  Model: "",
  AssetType_Id: "",
  CssColourBackground: "#eef2ff",
  CssColourBorder: "#c7d2fe",
  CssColourText: "#3730a3",
  Order: "",
};

const Tabs = [
  { id: "1", name: "Statuses" },
  { id: "2", name: "Types" },
  { id: "3", name: "Groups" },
];

export default function AssetSettings() {
  const dispatch = useDispatch();
  const [activeTab, setActiveTab] = useState("1");

  // ---------------------------------------------------------------- Asset Type
  const {
    listData,
    listLoading,
    singleData,
    createResponse,
    createLoading,
    updateResponse,
    updateLoading,
    deleteResponse,
    deleteLoading,
  } = useSelector((state) => ({
    listData: state.AssetType.assetTypeList?.assettype_list,
    listLoading: state.AssetType.assetTypeListLoading,
    singleData: state.AssetType.assetTypeData?.assettype_data,
    createResponse: state.AssetType.assetTypeCreate,
    createLoading: state.AssetType.assetTypeCreateLoading,
    updateResponse: state.AssetType.assetTypeUpdate,
    updateLoading: state.AssetType.assetTypeUpdateLoading,
    deleteResponse: state.AssetType.assetTypeDelete,
    deleteLoading: state.AssetType.assetTypeDeleteLoading,
  }));

  const [modal, setModal] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [form, setForm] = useState(EMPTY_FORM);
  const [deleteModal, setDeleteModal] = useState(false);
  const [deleteId, setDeleteId] = useState(null);

  // ------------------------------------------------------------- Asset Status
  const { assetStatusListApi, assetStatusCreateApi, assetStatusUpdateApi, assetStatusDeleteApi } =
    useSelector((state) => ({
      assetStatusListApi: state.AssetStatus.assetStatusList?.assetstatus_list,
      assetStatusCreateApi: state.AssetStatus.assetStatusCreate,
      assetStatusUpdateApi: state.AssetStatus.assetStatusUpdate,
      assetStatusDeleteApi: state.AssetStatus.assetStatusDelete,
    }));

  const [statusList, setStatusList] = useState([]);
  const [createStatus, setCreateStatus] = useState(EMPTY_STATUS);
  const [updateItemStatus, setUpdateItemStatus] = useState({});
  const [deleteStatus, setDeleteStatus] = useState("");
  const [statusDeleteModal, setStatusDeleteModal] = useState(false);

  // -------------------------------------------------------------- Asset Group
  const {
    groupListData,
    groupListLoading,
    groupSingleData,
    groupCreateResponse,
    groupCreateLoading,
    groupUpdateResponse,
    groupUpdateLoading,
    groupDeleteResponse,
    groupDeleteLoading,
  } = useSelector((state) => ({
    groupListData: state.AssetGroup.assetGroupList?.assetgroup_list,
    groupListLoading: state.AssetGroup.assetGroupListLoading,
    groupSingleData: state.AssetGroup.assetGroupData?.assetgroup_data,
    groupCreateResponse: state.AssetGroup.assetGroupCreate,
    groupCreateLoading: state.AssetGroup.assetGroupCreateLoading,
    groupUpdateResponse: state.AssetGroup.assetGroupUpdate,
    groupUpdateLoading: state.AssetGroup.assetGroupUpdateLoading,
    groupDeleteResponse: state.AssetGroup.assetGroupDelete,
    groupDeleteLoading: state.AssetGroup.assetGroupDeleteLoading,
  }));

  const [groupModal, setGroupModal] = useState(false);
  const [groupIsEdit, setGroupIsEdit] = useState(false);
  const [groupForm, setGroupForm] = useState(EMPTY_GROUP_FORM);
  const [groupDeleteModal, setGroupDeleteModal] = useState(false);
  const [groupDeleteId, setGroupDeleteId] = useState(null);

  useEffect(() => {
    dispatch(assetTypeList());
    dispatch(assetStatusList());
    dispatch(assetGroupList());
  }, []);

  // ======================================================== Asset Type effects
  // Populate form when single record loads for edit
  useEffect(() => {
    if (!isEdit || isEmpty(singleData)) return;
    setForm({
      Id: singleData.Id,
      Name: singleData.Name || "",
      Description: singleData.Description || "",
      CssColourBackground: singleData.CssColourBackground || "#ffffff",
      CssColourBorder: singleData.CssColourBorder || "#cccccc",
      CssColourText: singleData.CssColourText || "#000000",
      Order: singleData.Order ?? "",
    });
    setModal(true);
  }, [singleData, isEdit]);

  useEffect(() => {
    if (isEmpty(createResponse)) return;
    if (createResponse?.status === 200) {
      toast.success(createResponse.message);
      dispatch(assetTypeList());
      setModal(false);
      setForm(EMPTY_FORM);
    } else {
      toast.error(createResponse.message);
    }
    dispatch(assetTypeCreateSuccess([]));
  }, [createResponse]);

  useEffect(() => {
    if (isEmpty(updateResponse)) return;
    if (updateResponse?.status === 200) {
      toast.success(updateResponse.message);
      dispatch(assetTypeList());
      setModal(false);
      setForm(EMPTY_FORM);
    } else {
      toast.error(updateResponse.message);
    }
    dispatch(assetTypeUpdateSuccess([]));
  }, [updateResponse]);

  useEffect(() => {
    if (isEmpty(deleteResponse)) return;
    if (deleteResponse?.status === 200) {
      toast.success(deleteResponse.message);
      dispatch(assetTypeList());
      setDeleteModal(false);
      setDeleteId(null);
    } else {
      toast.error(deleteResponse.message);
    }
    dispatch(assetTypeDeleteSuccess([]));
  }, [deleteResponse]);

  const openCreate = () => {
    setIsEdit(false);
    setForm(EMPTY_FORM);
    setModal(true);
  };
  const openEdit = (id) => {
    setIsEdit(true);
    dispatch(assetTypeData({ id }));
  };
  const f = (key) => (e) => setForm((p) => ({ ...p, [key]: e.target.value }));

  const handleSubmit = () => {
    if (!form.Name?.trim()) {
      toast.error("Name is required");
      return;
    }
    const payload = [
      {
        ...(isEdit && { Id: form.Id }),
        Name: form.Name,
        Description: form.Description,
        CssColourBackground: form.CssColourBackground,
        CssColourBorder: form.CssColourBorder,
        CssColourText: form.CssColourText,
        Order: form.Order !== "" ? Number(form.Order) : null,
      },
    ];
    isEdit
      ? dispatch(assetTypeUpdate(payload))
      : dispatch(assetTypeCreate(payload));
  };

  const isSaving = createLoading || updateLoading;

  // ======================================================= Asset Group effects
  useEffect(() => {
    if (!groupIsEdit || isEmpty(groupSingleData)) return;
    setGroupForm({
      Id: groupSingleData.Id,
      Name: groupSingleData.Name || "",
      Description: groupSingleData.Description || "",
      Brand: groupSingleData.Brand || "",
      Model: groupSingleData.Model || "",
      AssetType_Id: groupSingleData.AssetType_Id || "",
      CssColourBackground: groupSingleData.CssColourBackground || "#eef2ff",
      CssColourBorder: groupSingleData.CssColourBorder || "#c7d2fe",
      CssColourText: groupSingleData.CssColourText || "#3730a3",
      Order: groupSingleData.Order ?? "",
    });
    setGroupModal(true);
  }, [groupSingleData, groupIsEdit]);

  useEffect(() => {
    if (isEmpty(groupCreateResponse)) return;
    if (groupCreateResponse?.status === 200) {
      toast.success(groupCreateResponse.message);
      dispatch(assetGroupList());
      setGroupModal(false);
      setGroupForm(EMPTY_GROUP_FORM);
    } else {
      toast.error(groupCreateResponse.message);
    }
    dispatch(assetGroupCreateSuccess([]));
  }, [groupCreateResponse]);

  useEffect(() => {
    if (isEmpty(groupUpdateResponse)) return;
    if (groupUpdateResponse?.status === 200) {
      toast.success(groupUpdateResponse.message);
      dispatch(assetGroupList());
      setGroupModal(false);
      setGroupForm(EMPTY_GROUP_FORM);
    } else {
      toast.error(groupUpdateResponse.message);
    }
    dispatch(assetGroupUpdateSuccess([]));
  }, [groupUpdateResponse]);

  useEffect(() => {
    if (isEmpty(groupDeleteResponse)) return;
    if (groupDeleteResponse?.status === 200) {
      toast.success(groupDeleteResponse.message);
      dispatch(assetGroupList());
      setGroupDeleteModal(false);
      setGroupDeleteId(null);
    } else {
      toast.error(groupDeleteResponse.message);
    }
    dispatch(assetGroupDeleteSuccess([]));
  }, [groupDeleteResponse]);

  const openGroupCreate = () => {
    setGroupIsEdit(false);
    setGroupForm(EMPTY_GROUP_FORM);
    setGroupModal(true);
  };
  const openGroupEdit = (id) => {
    setGroupIsEdit(true);
    dispatch(assetGroupData({ id }));
  };
  const gf = (key) => (e) => setGroupForm((p) => ({ ...p, [key]: e.target.value }));

  const handleGroupSubmit = () => {
    if (!groupForm.Name?.trim()) {
      toast.error("Name is required");
      return;
    }
    const payload = [
      {
        ...(groupIsEdit && { Id: groupForm.Id }),
        Name: groupForm.Name,
        Description: groupForm.Description,
        Brand: groupForm.Brand,
        Model: groupForm.Model,
        AssetType_Id: groupForm.AssetType_Id !== "" ? Number(groupForm.AssetType_Id) : null,
        CssColourBackground: groupForm.CssColourBackground,
        CssColourBorder: groupForm.CssColourBorder,
        CssColourText: groupForm.CssColourText,
        Order: groupForm.Order !== "" ? Number(groupForm.Order) : null,
      },
    ];
    groupIsEdit
      ? dispatch(assetGroupUpdate(payload))
      : dispatch(assetGroupCreate(payload));
  };

  const groupIsSaving = groupCreateLoading || groupUpdateLoading;
  const typeNameById = (id) =>
    (listData || []).find((t) => String(t.Id) === String(id))?.Name || "-";

  // ====================================================== Asset Status effects
  useEffect(() => {
    setStatusList(assetStatusListApi?.slice().sort((a, b) => b.Id - a.Id) || []);
  }, [assetStatusListApi]);

  const handleCreateNewStatus = () => {
    dispatch(assetStatusCreate([createStatus]));
  };

  useEffect(() => {
    if (isEmpty(assetStatusCreateApi)) return;
    if (assetStatusCreateApi.status === 200) {
      toast.success(assetStatusCreateApi.message);
      dispatch(assetStatusList());
      setCreateStatus(EMPTY_STATUS);
    } else {
      toast.error(assetStatusCreateApi.message);
    }
    dispatch(assetStatusCreateSuccess([]));
  }, [assetStatusCreateApi]);

  // Debounced update when a status row is edited inline
  useEffect(() => {
    if (isEmpty(updateItemStatus)) return;
    const payload = {
      Id: updateItemStatus?.Id,
      Name: updateItemStatus?.Name,
      CssColourBackground: updateItemStatus?.CssColourBackground,
      CssColourText: updateItemStatus?.CssColourText,
      FlagActive: updateItemStatus?.FlagActive,
      FlagComplete: updateItemStatus?.FlagComplete,
    };
    const delayUpdate = setTimeout(() => {
      dispatch(assetStatusUpdate([payload]));
    }, 500);
    return () => clearTimeout(delayUpdate);
  }, [updateItemStatus]);

  useEffect(() => {
    if (isEmpty(assetStatusUpdateApi)) return;
    if (assetStatusUpdateApi.status === 200) {
      toast.success(assetStatusUpdateApi.message);
      dispatch(assetStatusList());
    } else {
      toast.error(assetStatusUpdateApi.message);
    }
    dispatch(assetStatusUpdateSuccess([]));
  }, [assetStatusUpdateApi]);

  useEffect(() => {
    if (isEmpty(assetStatusDeleteApi)) return;
    if (assetStatusDeleteApi.status === 200) {
      toast.success(assetStatusDeleteApi.message);
      dispatch(assetStatusList());
      setStatusDeleteModal(false);
      setDeleteStatus("");
    } else {
      toast.error(assetStatusDeleteApi.message);
    }
    dispatch(assetStatusDeleteSuccess([]));
  }, [assetStatusDeleteApi]);

  return (
    <>
      {/* Asset Type delete confirmation */}
      <DeleteModal
        show={deleteModal}
        onDeleteClick={() => dispatch(assetTypeDelete([deleteId]))}
        onCloseClick={() => {
          setDeleteModal(false);
          setDeleteId(null);
        }}
      />

      {/* Asset Status delete confirmation */}
      <DeleteModal
        show={statusDeleteModal}
        onDeleteClick={() => dispatch(assetStatusDelete([deleteStatus]))}
        onCloseClick={() => {
          setStatusDeleteModal(false);
          setDeleteStatus("");
        }}
      />

      {/* Asset Group delete confirmation */}
      <DeleteModal
        show={groupDeleteModal}
        onDeleteClick={() => dispatch(assetGroupDelete([groupDeleteId]))}
        onCloseClick={() => {
          setGroupDeleteModal(false);
          setGroupDeleteId(null);
        }}
      />

      <AppModal
        open={modal}
        onClose={() => setModal(false)}
        title={isEdit ? "Edit Asset Type" : "Add Asset Type"}
        headerAccent="indigo"
        size="sm"
        loading={isSaving}
        onSubmit={handleSubmit}
        submitLabel={isEdit ? "Update" : "Create"}
        submitColor="primary"
      >
        <Row className="g-3">
          <Col lg={12}>
            <Label>Name *</Label>
            <Input
              value={form.Name}
              onChange={f("Name")}
              placeholder="e.g. IT Equipment, Clothing"
            />
          </Col>
          <Col lg={12}>
            <Label>Description</Label>
            <Input
              type="textarea"
              rows={3}
              value={form.Description}
              onChange={f("Description")}
            />
          </Col>
          <Col lg={4}>
            <Label>Background</Label>
            <Input
              type="color"
              value={form.CssColourBackground}
              onChange={f("CssColourBackground")}
            />
          </Col>
          <Col lg={4}>
            <Label>Border</Label>
            <Input
              type="color"
              value={form.CssColourBorder}
              onChange={f("CssColourBorder")}
            />
          </Col>
          <Col lg={4}>
            <Label>Text</Label>
            <Input
              type="color"
              value={form.CssColourText}
              onChange={f("CssColourText")}
            />
          </Col>
          <Col lg={6}>
            <Label>Order</Label>
            <Input
              type="number"
              value={form.Order}
              onChange={f("Order")}
              placeholder="0"
              min={0}
            />
          </Col>
          <Col lg={6} className="d-flex align-items-end">
            <div className="p-2 rounded border w-100 d-flex align-items-center gap-2">
              <span
                className="badge px-3 py-2"
                style={{
                  background: form.CssColourBackground,
                  border: `1px solid ${form.CssColourBorder}`,
                  color: form.CssColourText,
                }}
              >
                {form.Name || "Preview"}
              </span>
            </div>
          </Col>
        </Row>
      </AppModal>

      {/* Asset Group create / edit */}
      <AppModal
        open={groupModal}
        onClose={() => setGroupModal(false)}
        title={groupIsEdit ? "Edit Asset Group" : "Add Asset Group"}
        headerAccent="indigo"
        size="sm"
        loading={groupIsSaving}
        onSubmit={handleGroupSubmit}
        submitLabel={groupIsEdit ? "Update" : "Create"}
        submitColor="primary"
      >
        <Row className="g-3">
          <Col lg={12}>
            <Label>Name *</Label>
            <Input
              value={groupForm.Name}
              onChange={gf("Name")}
              placeholder="e.g. A1 Dehumidifier"
            />
          </Col>
          <Col lg={6}>
            <Label>Brand</Label>
            <Input value={groupForm.Brand} onChange={gf("Brand")} placeholder="e.g. Ebac" />
          </Col>
          <Col lg={6}>
            <Label>Model</Label>
            <Input value={groupForm.Model} onChange={gf("Model")} placeholder="e.g. A1" />
          </Col>
          <Col lg={12}>
            <Label>Asset Type</Label>
            <Input type="select" value={groupForm.AssetType_Id} onChange={gf("AssetType_Id")}>
              <option value="">— Select type —</option>
              {(listData || []).map((t) => (
                <option key={t.Id} value={t.Id}>{t.Name}</option>
              ))}
            </Input>
          </Col>
          <Col lg={12}>
            <Label>Description</Label>
            <Input
              type="textarea"
              rows={2}
              value={groupForm.Description}
              onChange={gf("Description")}
            />
          </Col>
          <Col lg={4}>
            <Label>Background</Label>
            <Input type="color" value={groupForm.CssColourBackground} onChange={gf("CssColourBackground")} />
          </Col>
          <Col lg={4}>
            <Label>Border</Label>
            <Input type="color" value={groupForm.CssColourBorder} onChange={gf("CssColourBorder")} />
          </Col>
          <Col lg={4}>
            <Label>Text</Label>
            <Input type="color" value={groupForm.CssColourText} onChange={gf("CssColourText")} />
          </Col>
          <Col lg={6}>
            <Label>Order</Label>
            <Input type="number" value={groupForm.Order} onChange={gf("Order")} placeholder="0" min={0} />
          </Col>
          <Col lg={6} className="d-flex align-items-end">
            <div className="p-2 rounded border w-100 d-flex align-items-center gap-2">
              <span
                className="badge px-3 py-2"
                style={{
                  background: groupForm.CssColourBackground,
                  border: `1px solid ${groupForm.CssColourBorder}`,
                  color: groupForm.CssColourText,
                }}
              >
                {groupForm.Name || "Preview"}
              </span>
            </div>
          </Col>
        </Row>
      </AppModal>

      <SettingsPanel
        title="Asset Settings"
        description="Statuses, types and pooled groups used to track and classify your assets"
        actions={
          <Link to="/asset-list" className="btn btn-primary">
            <i className="ri-list-check align-bottom me-1" />
            View asset list
          </Link>
        }
        tabs={Tabs.map((item) => ({ value: item.id, label: item.name }))}
        value={activeTab}
        onChange={setActiveTab}
      >
        <TabContent activeTab={activeTab} className="pt-3">
          {/* ------------------------------------------------ Statuses tab */}
          <TabPane tabId="1">
            <StatusViewEditComponent
              statusList={statusList}
              setStatusList={setStatusList}
              createStatus={createStatus}
              setCreateStatus={setCreateStatus}
              handleCreateNewStatus={handleCreateNewStatus}
              setDeleteStatus={setDeleteStatus}
              setDeleteModal={setStatusDeleteModal}
              setUpdateItemStatus={setUpdateItemStatus}
              statusFlag={false}
            />
          </TabPane>

          {/* --------------------------------------------------- Types tab */}
          <TabPane tabId="2">
            <div className="d-flex justify-content-between align-items-center mb-3">
              <h5 className="mb-0">Asset Types</h5>
              <button className="btn btn-success btn-sm" onClick={openCreate}>
                <i className="ri-add-line align-bottom me-1"></i>Add Type
              </button>
            </div>

            {listLoading ? (
              <LoadingSpinner />
            ) : isEmpty(listData) ? (
              <div className="text-center text-muted py-4">
                <i className="ri-archive-line fs-1 d-block mb-2"></i>
                No asset types yet. Click <strong>Add Type</strong> to create
                one.
              </div>
            ) : (
              <div className="table-responsive">
                <table className="table table-hover align-middle mb-0">
                  <thead className="text-muted">
                    <tr>
                      <th>#</th>
                      <th>Name</th>
                      <th>Description</th>
                      <th>Colours</th>
                      <th>Order</th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody>
                    {[...(listData || [])]
                      .sort((a, b) => Number(a.Id) - Number(b.Id))
                      .map((item) => (
                        <tr key={item.Id}>
                          <td className="text-muted">#{item.Id}</td>
                          <td>
                            <Link
                              to={`/asset-details/${item.Id}/Overview`}
                              className="text-decoration-none"
                            >
                              <span
                                className="badge px-2 py-1"
                                style={{
                                  background:
                                    item.CssColourBackground || "#f1f5f9",
                                  border: `1px solid ${
                                    item.CssColourBorder || "#e2e8f0"
                                  }`,
                                  color: item.CssColourText || "#0f172a",
                                }}
                              >
                                {item.Name}
                              </span>
                            </Link>
                          </td>
                          <td
                            className="text-muted small"
                            style={{ maxWidth: 220 }}
                          >
                            <span className="text-truncate d-block">
                              {item.Description || "-"}
                            </span>
                          </td>
                          <td>
                            <div className="d-flex gap-1">
                              {[
                                item.CssColourBackground,
                                item.CssColourBorder,
                                item.CssColourText,
                              ].map((c, i) => (
                                <span
                                  key={i}
                                  style={{
                                    width: 18,
                                    height: 18,
                                    borderRadius: 4,
                                    background: c || "#f1f5f9",
                                    border: "1px solid #e2e8f0",
                                    display: "inline-block",
                                  }}
                                />
                              ))}
                            </div>
                          </td>
                          <td>{item.Order ?? "-"}</td>
                          <td>
                            <div className="d-flex gap-2 justify-content-end">
                              <Link
                                to={`/asset-details/${item.Id}/Overview`}
                                className="btn btn-soft-success btn-sm btn-icon"
                                title="View details"
                              >
                                <i className="ri-eye-line"></i>
                              </Link>
                              <button
                                className="btn btn-soft-info btn-sm btn-icon"
                                title="Edit"
                                onClick={() => openEdit(item.Id)}
                              >
                                <i className="ri-pencil-fill"></i>
                              </button>
                              <button
                                className="btn btn-soft-danger btn-sm btn-icon"
                                title="Delete"
                                disabled={deleteLoading}
                                onClick={() => {
                                  setDeleteId(item.Id);
                                  setDeleteModal(true);
                                }}
                              >
                                <i className="ri-delete-bin-fill"></i>
                              </button>
                            </div>
                          </td>
                        </tr>
                      ))}
                  </tbody>
                </table>
              </div>
            )}
          </TabPane>

          {/* -------------------------------------------------- Groups tab */}
          <TabPane tabId="3">
            <div className="d-flex justify-content-between align-items-center mb-3">
              <div>
                <h5 className="mb-0">Asset Groups</h5>
                <small className="text-muted">
                  Pools of interchangeable units. Dispatch can require &quot;any one of this group&quot;
                  instead of a specific asset.
                </small>
              </div>
              <button className="btn btn-success btn-sm" onClick={openGroupCreate}>
                <i className="ri-add-line align-bottom me-1"></i>Add Group
              </button>
            </div>

            {groupListLoading ? (
              <LoadingSpinner />
            ) : isEmpty(groupListData) ? (
              <div className="text-center text-muted py-4">
                <i className="ri-stack-line fs-1 d-block mb-2"></i>
                No asset groups yet. Click <strong>Add Group</strong> to create one.
              </div>
            ) : (
              <div className="table-responsive">
                <table className="table table-hover align-middle mb-0">
                  <thead className="text-muted">
                    <tr>
                      <th>#</th>
                      <th>Name</th>
                      <th>Brand</th>
                      <th>Model</th>
                      <th>Type</th>
                      <th>Members</th>
                      <th>Order</th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody>
                    {[...(groupListData || [])]
                      .sort((a, b) => Number(a.Id) - Number(b.Id))
                      .map((item) => (
                        <tr key={item.Id}>
                          <td className="text-muted">#{item.Id}</td>
                          <td>
                            <span
                              className="badge px-2 py-1"
                              style={{
                                background: item.CssColourBackground || "#eef2ff",
                                border: `1px solid ${item.CssColourBorder || "#c7d2fe"}`,
                                color: item.CssColourText || "#3730a3",
                              }}
                            >
                              {item.Name}
                            </span>
                          </td>
                          <td className="text-muted small">{item.Brand || "-"}</td>
                          <td className="text-muted small">{item.Model || "-"}</td>
                          <td className="text-muted small">{typeNameById(item.AssetType_Id)}</td>
                          <td>
                            <span className="badge bg-light text-dark">
                              {item.MemberCount ?? 0}
                            </span>
                          </td>
                          <td>{item.Order ?? "-"}</td>
                          <td>
                            <div className="d-flex gap-2 justify-content-end">
                              <button
                                className="btn btn-soft-info btn-sm btn-icon"
                                title="Edit"
                                onClick={() => openGroupEdit(item.Id)}
                              >
                                <i className="ri-pencil-fill"></i>
                              </button>
                              <button
                                className="btn btn-soft-danger btn-sm btn-icon"
                                title="Delete"
                                disabled={groupDeleteLoading}
                                onClick={() => {
                                  setGroupDeleteId(item.Id);
                                  setGroupDeleteModal(true);
                                }}
                              >
                                <i className="ri-delete-bin-fill"></i>
                              </button>
                            </div>
                          </td>
                        </tr>
                      ))}
                  </tbody>
                </table>
              </div>
            )}
          </TabPane>
        </TabContent>
      </SettingsPanel>
    </>
  );
}